import React from 'react'
import PropTypes from 'prop-types'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    marginBottom: theme.spacing(0.5),
  },
}))

const InputLabel = ({ text }) => {
  const classes = useStyles()

  return (
    <div>
      <InternationalizedFormattedText variant='body2' className={classes.inputLabel} id={text} />
    </div>
  )
}

InputLabel.propTypes = {
  text: PropTypes.string.isRequired,
}

export default InputLabel
